import {
  changeDate,
  confirmReportRequest,
  getCityId,
  http,
  HTTP_URL,
  locate_by_lon_lat,
  orderDelete,
  reminder,
  getPackageDetailV2
} from "./api";
import wx from "weixin-js-sdk"; // 兼容vivo
import { apply } from "./miniapp";

import { AES } from "jscrypto/es6/AES";
import { Utf8 } from "jscrypto/es6/Utf8";
import store from "@/store";

function addChannel(payload) {
  let channel = sessionStorage.getItem("channel");
  if (!channel || payload.link.indexOf("channel") !== -1) {
    return payload;
  }
  payload.link = `${payload.link}${
    payload.link.indexOf("?") !== -1 ? "&" : "?"
  }channel=${channel}`;
  return payload;
}
//金额格式化
export function formatPrice(val, keepPoint = true) {
  const priceArr = (val / 100).toFixed(2).split(".");
  if (keepPoint) {
    return priceArr[0] + "." + priceArr[1];
  } else {
    return Number(priceArr[0] + "." + priceArr[1]);
  }
}
// 微信分享
export function wechatShare(payload) {
  // 访问渠道为非微信浏览器或者小程序时，不调用微信分享
  if (BROSWER_TYPE !== "1" || ISWEBVIEW) {
    return;
  }
  // 微信分享前带上channel
  payload = addChannel(payload);
  // // 不执行请求，直接设置分享参数
  // if (!payload.implementRequest) {
  //   wx.ready(function () {
  //     wx.onMenuShareAppMessage(payload);
  //     wx.onMenuShareTimeline(payload);
  //   });
  //   wx.error(function (res) {
  //     console.log(res);
  //   });
  //   return;
  // }
  // 重新获取设置分享配置，并设置分享参数

  http({
    url: "/home/get_js_sign_package?url=" + encodeURIComponent(document.URL),
    prefix: appPath
  }).then(res => {
    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: res.appid, // 必填，公众号的唯一标识
      timestamp: res.timestamp, // 必填，生成签名的时间戳
      nonceStr: res.noncestr, // 必填，生成签名的随机串
      signature: res.signature, // 必填，签名，见附录1
      jsApiList: ["onMenuShareTimeline", "onMenuShareAppMessage"], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      openTagList: ['wx-open-launch-weapp'],
    });
    wx.ready(function() {
      wx.onMenuShareAppMessage(payload);
      wx.onMenuShareTimeline(payload);
    });
    wx.error(function(res) {
      console.log("error");
    });
  });
}

export function wechatSDK(options) {
  // 访问渠道为非微信浏览器或者小程序时，不调用微信分享
  if (BROSWER_TYPE !== "1" || ISWEBVIEW) {
    return;
  }
  http({
    url:
      "/home/get_js_sign_package?url=" +
      encodeURIComponent(document.URL.split("#")[0]),
    prefix: appPath
  }).then(response => {
    wxConfig(response);
  });

  function wxConfig(response) {
    let res = response;
    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: res.appid, // 必填，公众号的唯一标识
      timestamp: res.timestamp, // 必填，生成签名的时间戳
      nonceStr: res.noncestr, // 必填，生成签名的随机串
      signature: res.signature, // 必填，签名，见附录1
      jsApiList: options.jsApiList || [], /// 必填，需要使用的JS接口列表，所有JS接口列表见附录2
      openTagList:options.openTagList ||[]
    });
    wx.ready(function(res) {
      options.success && options.success(res);
    });

    wx.error(function(res) {
      options.fail && options.fail(res);
    });
  }
}

// jsdk config 小程序才调用此方法
export function wechatJSDKConfig(options) {
  if (!isMiniProgram()) {
    options.success(res);
    return;
  }
  http({
    url:
      "/home/get_js_sign_package?url=" +
      encodeURIComponent(document.URL.split("#")[0]),
    prefix: appPath
  }).then(response => {
    wxConfig(response);
  });

  function wxConfig(response) {
    let res = response;
    wx.config({
      debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
      appId: res.appid, // 必填，公众号的唯一标识
      timestamp: res.timestamp, // 必填，生成签名的时间戳
      nonceStr: res.noncestr, // 必填，生成签名的随机串
      signature: res.signature, // 必填，签名，见附录1
      jsApiList: options.jsApiList || [] /// 必填，需要使用的JS接口列表，所有JS接口列表见附录2
    });
    wx.ready(function(res) {
      options.success && options.success(res);
    });

    wx.error(function(res) {
      options.fail && options.fail(res);
    });
  }
}

// 处理推荐机构
export function filterRecommend(arr, local = true) {
  let result = [];
  let res = arr.sort(compare2("org_avg_score", "level_id"));
  // console.log(1,res[0].org_avg_score, res[1].org_avg_score);
  // 如果有定位，推荐机构为2个最高分和2个最近机构
  if (local) {
    // 删除前2个并返回
    // console.log(2,res[0].org_avg_score, res[1].org_avg_score);

    let result1 = res.splice(0, 2);
    // console.log(3,res[0].org_avg_score, res[1].org_avg_score, result1[0].org_avg_score, result1[1].org_avg_score)

    let result2 = res.sort(compare2("distance", "level_id")).splice(0, 2);
    result = result1.concat(result2);
  } else {
    // 无定位推荐机构为前4个高分机构
    result = res.splice(0, 4);
  }
  // console.log(4,result[0].org_avg_score, result[1].org_avg_score, result[2].org_avg_score, result[3].org_avg_score)

  return result;
}

// 降序,优先排attr1
export function compare(attr1, attr2) {
  return function(a, b) {
    // return val2 - val1;
    if (attr2) {
      return b[attr1] - a[attr1] == 0
        ? b[attr2] - a[attr2]
        : b[attr1] - a[attr1];
    } else {
      return b[attr1] - a[attr1];
    }
  };
}

// 改造compare2
export function compare2(type, level_id) {
  return function(a, b) {
    // return val2 - val1;
    if (a[level_id] == "3" && b[level_id] != "3") {
      return -1;
    }

    if (a[level_id] != "3" && b[level_id] == "3") {
      return 1;
    }

    if (type == "org_avg_score") {
      if (
        (a[level_id] == "3" && b[level_id] == "3") ||
        (a[level_id] != "3" && b[level_id] != "3")
      ) {
        return b[type] - a[type];
      }
    }

    if (type == "distance") {
      if (
        (a[level_id] == "3" && b[level_id] == "3") ||
        (a[level_id] != "3" && b[level_id] != "3")
      ) {
        return a[type] - b[type];
      }
    }
  };
}

/*
  判断是否pc
*/
export function IsPC() {
  var userAgentInfo = navigator.userAgent;
  var Agents = new Array(
    "Android",
    "iPhone",
    "SymbianOS",
    "Windows Phone",
    "iPad",
    "iPod"
  );
  var flag = true;
  for (var v = 0; v < Agents.length; v++) {
    if (userAgentInfo.indexOf(Agents[v]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
}

// 拼接params
export function param(data) {
  var url = "";
  for (var k in data) {
    let val = data[k] !== undefined ? data[k] : "";
    url += `&${k}=${data[k]}`;
  }
  return url ? url.substring(1) : "";
}

/**
 * @param strBirthday：指的是出生日期，格式为"1990-01-01"
 */
export function getAge(strBirthday) {
  var returnAge,
    strBirthdayArr = strBirthday.split("-"),
    birthYear = strBirthdayArr[0],
    birthMonth = strBirthdayArr[1],
    birthDay = strBirthdayArr[2],
    d = new Date(),
    nowYear = d.getFullYear(),
    nowMonth = d.getMonth() + 1,
    nowDay = d.getDate();
  if (nowYear == birthYear) {
    returnAge = 0; //同年 则为0周岁
  } else {
    var ageDiff = nowYear - birthYear; //年之差
    if (ageDiff > 0) {
      if (nowMonth == birthMonth) {
        var dayDiff = nowDay - birthDay; //日之差
        if (dayDiff < 0) {
          returnAge = ageDiff - 1;
        } else {
          returnAge = ageDiff;
        }
      } else {
        var monthDiff = nowMonth - birthMonth; //月之差
        if (monthDiff < 0) {
          returnAge = ageDiff - 1;
        } else {
          returnAge = ageDiff;
        }
      }
    } else {
      returnAge = -1; //返回-1 表示出生日期输入错误 晚于今天
    }
  }
  return returnAge; //返回周岁年龄
}

// 提取url query参数
export function getUrlParams(url = window.location.href) {
  url = url.substr(url.indexOf("?") + 1);
  var arr = url.split("&");
  var obj = {};
  for (let i = 0; i < arr.length; i++) {
    var key = arr[i].split("=")[0];
    var val = arr[i].split("=")[1];
    obj[key] = val;
  }
  return obj;
}

// 提取url指定参数(个检平台专用)
export function getUrlSpecifiedParam(paraName) {
  let url = document.location.toString();
  let replace = url.match(/#(\S*)\?/); // 获取#到？之间的一个数组
  replace && (url = url.replace(`#${replace[1]}?`, "?")); // 把url#后面的name值去掉，保留？后面的参数

  let arrObj = url.split("?");
  if (arrObj.length >= 3) {
    url = "";
    for (let i = 0, len = arrObj.length; i < len; i++) {
      url += i === 0 ? arrObj[0] + "?" : "&" + arrObj[i];
    }
    arrObj = url.split("?");
  }
  if (arrObj.length > 1) {
    let arrPara = arrObj[1].split(/[&#]/);
    let arr;
    for (let i = 0; i < arrPara.length; i++) {
      arr = arrPara[i].split("=");
      if (arr != null && arr[0] == paraName) {
        return arr[1];
      }
    }
    return "";
  } else {
    return "";
  }
}

// 提取url 所带id
export function getUrlInfo(url, route) {
  // 3：#/route/
  var id = url.substr(route.length + 3);
  return id;
}

// 遍历url中的query，如果跟数据中的值对应上，则将这个数据设置为默认选中状态
export function handleFilterData(data, querys) {
  for (const key in querys) {
    if (!querys[key]) {
      continue;
    }
    if (typeof querys[key] !== "string") {
      querys[key] = querys[key].toString();
    }
    const queryArr = querys[key].split(",");
    for (let i = 0, len1 = data.length; i < len1; i++) {
      if (data[i].code === key && data[i].options) {
        for (let j = 0, len2 = data[i].options.length; j < len2; j++) {
          for (let k = 0, len3 = queryArr.length; k < len3; k++) {
            if (data[i].options[j].code == queryArr[k]) {
              data[i].options[j].checked = true;
            }
          }
        }
      }
    }
  }
  return data;
}

// 排序 传入数组和排序key
// sort_key: 升/降_要排序的属性
export function sortData(list, sort_key) {
  // 用了’_‘作分割属性名和排序类型（升/降）
  let ordering = sort_key.split("_")[0];
  // 获取_后面的作为attr进行排序
  let attr = sort_key.split("_")[1];
  list.sort(compare(attr, "id"));
  ordering === "min" && list.reverse();
  return list;
}

// 过滤数据，传入list,筛选词，不同匹配规则数组
export function filterList({
  list = [],
  conditionData = {},
  strictArr = [],
  easyArr = [],
  min_price = "",
  max_price = ""
}) {
  for (const key in conditionData) {
    if (key === "sort_key") continue;
    if (!conditionData[key]) continue;
    // 全等
    if (strictArr.indexOf(key) != -1) {
      let condition = conditionData[key].split(",");
      list = list.filter(item => {
        // console.log(key ,condition, item[key], condition.indexOf(''+item[key]) != -1);
        return condition.indexOf("" + item[key]) != -1;
      });
    }
    // 非全等
    if (easyArr.indexOf(key) != -1) {
      let condition = conditionData[key].split(",").join("|");
      list = list.filter(item => {
        // console.log(key ,condition, item[key], new RegExp(condition).test(item[key]));
        // 匹配出所有item.packageName有conditionData[key]的item
        return new RegExp(condition).test(item[key]);
      });
    }
    if (min_price || max_price) {
      list = list.filter(item => {
        // console.log(key ,condition, item[key], condition.indexOf(''+item[key]) != -1);
        if (min_price && !max_price) {
          return item.min_price / 100 > Number(min_price);
        } else if (max_price && !min_price) {
          return item.min_price / 100 > Number(max_price);
        } else if (min_price && max_price) {
          return (
            item.min_price / 100 > Number(min_price) &&
            item.min_price / 100 < Number(max_price)
          );
        }
      });
    }
  }
  return list;
}

// 处理机构排期
export function formatMedicalTime(list) {
  for (var i = 0; i < list.length; i++) {
    if (list[i].text.indexOf("|") !== -1) {
      var remain = list[i].text.trim().replace(/(.*?)\|(\d*)/, "$2");
      if (remain * 1 <= "0") {
        // 把约满的日子去掉
        list.splice(i, 1);
        i--;
      } else {
        list[i].text = list[i].text.trim().replace(/(.*?)\|(\d*)/, "$1");
      }
    } else {
      list[i].text = list[i].text.trim();
    }
  }

  return list;
}

// 格式化日期
export function formatTime(time) {
  return time ? time.replace(/-/g, "/") : "";
}

// 格式化日期，输入：日期对象，输出：YYYY-MM-DD
export function getNowFormatDate(dateObj) {
  let date = new Date();
  let year = date.getFullYear();
  let month = date.getMonth() + 1;
  let strDate = date.getDate();
  if (month >= 1 && month <= 9) {
    month = "0" + month;
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = "0" + strDate;
  }
  return year + "-" + month + "-" + strDate;
}

// 按格式输出日期

export function formatDate(fmt, date) {
  var o = {
    "y+": date.getFullYear(),
    "M+": date.getMonth() + 1, // 月份
    "d+": date.getDate(), // 日
    "h+": date.getHours(), // 小时
    "m+": date.getMinutes(), // 分
    "s+": date.getSeconds(), // 秒
    "q+": Math.floor((date.getMonth() + 3) / 3), // 季度
    S: date.getMilliseconds() // 毫秒
  };
  // 年份格式
  if (/(y+)/.test(fmt)) {
    fmt = fmt.replace(
      RegExp.$1,
      (date.getFullYear() + "").substr(4 - RegExp.$1.length)
    );
  }
  for (var k in o) {
    if (new RegExp("(" + k + ")").test(fmt)) {
      // fmt = fmt.replace(RegExp.$1, o[k])
      // 根据要求补0
      fmt = fmt.replace(
        RegExp.$1,
        RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length)
      );
    }
  }
  return fmt;
}

export function uniq(array) {
  let temp = []; // 一个新的临时数组
  for (let i = 0; i < array.length; i++) {
    if (temp.indexOf(array[i]) === -1) {
      temp.push(array[i]);
    }
  }
  return temp;
}

var EARTH_RADIUS = 6378137.0; // 单位M
var PI = Math.PI;

function getRad(d) {
  return (d * PI) / 180.0;
}

// 添加单位
export function addmeter(arr) {
  var vm = this;
  arr.forEach((item, index) => {
    if (item.distance > 99) {
      item.DISTANCE = ">99km";
    } else if (item.distance >= 1) {
      item.DISTANCE = Math.round(item.distance * 10) / 10 + "km";
    } else if (item.distance < 1) {
      item.DISTANCE = Math.round(item.distance * 1000) + "m";
    }
  });
  return arr;
}

// 隐藏部分字符
export function normalizeStr(str, len1, len2) {
  var len = str.length - len1 - len2;
  var xin = "";
  for (var i = 0; i < len; i++) {
    xin += "*";
  }
  return str.substring(0, len1) + xin + str.substring(str.length - len2);
}

// 计算两点之间的距离
export function getFlatternDistance(lat1, lng1, lat2, lng2) {
  if (!lat1 || !lng1 || !lat2 || !lng2) {
    return null;
  }
  var radLat1 = (lat1 * Math.PI) / 180.0;
  var radLat2 = (lat2 * Math.PI) / 180.0;
  var a = radLat1 - radLat2;
  var b = (lng1 * Math.PI) / 180.0 - (lng2 * Math.PI) / 180.0;
  var s =
    2 *
    Math.asin(
      Math.sqrt(
        Math.pow(Math.sin(a / 2), 2) +
          Math.cos(radLat1) * Math.cos(radLat2) * Math.pow(Math.sin(b / 2), 2)
      )
    );
  s = s * 6378.137;
  s = Math.round(s * 10000) / 10000;
  return s;
}

// new Map
function Maps(vm) {
  return new Promise(function(resolve, reject) {
    resolve(vm);
  });
}

export function setCookie(name, value) {
  var exp = new Date();
  exp.setTime(exp.getTime() + 2 * 60 * 60 * 1000);
  document.cookie =
    name +
    "=" +
    escape(value) +
    ";expires=" +
    exp.toGMTString() +
    ";domain=dsjkyy.com;path=/";

  document.cookie =
    name +
    "=" +
    escape(value) +
    ";expires=" +
    exp.toGMTString() +
    ";domain=apps.dsjkyy.com;path=/";
}

export function getCookie(name) {
  var arr;
  var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
  else return null;
}

function BMaps(vm) {
  return new Promise(function(resolve, reject) {
    // 用户已经拒绝定位了
    // if( sessionStorage.getItem('BMapsLocation') && sessionStorage.getItem('BMapsLocation') == 'reject' ) {
    //   reject('用户已经拒绝定位了');
    //   return;
    // }

    if (localStorage.getItem("myLocationInfo")) {
      // var myLocationInfo = sessionStorage.getItem('myLocationInfo');
      // var lon_lat = sessionStorage.getItem('lon_lat');
      sessionStorage.setItem(
        "myLocationInfo",
        localStorage.getItem("myLocationInfo")
      );
      JSON.parse(localStorage.getItem("myLocationInfo")).lon_lat &&
        sessionStorage.setItem(
          "lon_lat",
          JSON.parse(localStorage.getItem("myLocationInfo")).lon_lat
        );
      resolve();
      return;
    }

    // 判断是否是小程序进来的
    isMiniProgram(function(res) {
      if (res) {
        var lon_lat = sessionStorage.getItem("lon_lat");
        if (!lon_lat) {
          reject();
          return;
        }
        locate_by_lon_lat(vm, lon_lat).then(function(data) {
          var showNoserver = false;
          if (store.state && data.city_id != store.state.currentCity.city_id) {
            vm.$refs.confirm.show();
            showNoserver = true;
          }
          var info = {
            city_name: data.name,
            city_id: data.city_id,
            lon_lat: lon_lat,
            date: Math.floor(new Date().getTime() / 1000)
          };
          sessionStorage.setItem("myLocationInfo", JSON.stringify(info));
          localStorage.setItem("myLocationInfo", JSON.stringify(info));
          resolve(showNoserver);
          resolve(showNoserver);
        });
        return;
      }

      checkMapsLoad(function(B) {
        if (B === false || typeof BMap === "undefined") {
          sessionStorage.setItem("BMapsLocation", "reject");
          reject("地图加载失败");
          return;
        }
        var geolocation = new BMap.Geolocation();
        geolocation.getCurrentPosition(
          function(r) {
            if (
              this.getStatus() == BMAP_STATUS_SUCCESS &&
              r.address &&
              r.point &&
              !sessionStorage.getItem("BMapsLocation")
            ) {
              var cityName = r.address.city.substr(0, r.address.city.length - 1)
                ? r.address.city.length < 3
                  ? r.address.city
                  : r.address.city.substr(0, r.address.city.length - 1)
                : "深圳";

              getCityId(vm, cityName).then(function(response) {
                if (response.code == 200 && response.data) {
                  var info = {
                    city_name: cityName,
                    city_id: response.data.id,
                    area_code: response.data.standard_code,
                    lon_lat: r.point.lng + "," + r.point.lat,
                    date: Math.floor(new Date().getTime() / 1000)
                  };
                  sessionStorage.setItem(
                    "myLocationInfo",
                    JSON.stringify(info)
                  );
                  sessionStorage.setItem(
                    "lon_lat",
                    r.point.lng + "," + r.point.lat
                  );
                  localStorage.setItem("myLocationInfo", JSON.stringify(info));
                  var showNoserver = false;
                  if (
                    store.state &&
                    store.state.currentCity.city_id != response.data.id
                  ) {
                    vm.$refs.confirm.show();
                    showNoserver = true;
                  }
                  resolve(showNoserver);
                } else {
                  reject();
                }
              });
            } else {
              sessionStorage.setItem("BMapsLocation", "reject");
              reject("用户拒绝定位");
            }
          },
          function() {
            console.log("定位失败了。。。");
            vm.toastOpt = {
              title: "定位失败，请手动切换城市",
              icon: "fail",
              duration: 5000
            };
            vm.$refs.toast.show();
            reject("百度定位失败");
          },
          {
            timeout: 4000,
            enableHighAccuracy: true
          }
        );
      });

      // }
    });
  });
}

export function checkMapsLoad(next) {
  // 被发催款邮件,先隐藏,待解开 start
  next(false);
  return;
  // 被发催款邮件,先隐藏,待解开 end

  // console.log("初始化百度地图脚本...");
  var timer = null;
  const AK = "Gl2ghv7iHfbFBFvRT1K895muGm6bnxT6";
  const BMap_URL =
    "https://api.map.baidu.com/api?v=2.0&ak=" +
    AK +
    "&s=1&callback=onBMapCallback";
  timer = setTimeout(() => {
    window.onBMapCallback = null;
    next(false);
  }, 10000);

  // 如果已加载直接返回
  if (typeof BMap !== "undefined") {
    clearTimeout(timer);
    next(BMap);
    return;
  }
  // 百度地图异步加载回调处理
  window.onBMapCallback = function() {
    console.log("百度地图脚本初始化成功...");
    clearTimeout(timer);
    next(BMap);
  };

  // 插入script脚本
  let scriptNode = document.createElement("script");
  scriptNode.setAttribute("type", "text/javascript");
  scriptNode.setAttribute("src", BMap_URL);
  document.body.appendChild(scriptNode);
}

export function newAddDistance(vm) {
  return new Promise(function(resolve, reject) {
    return Maps(vm)
      .then(function() {
        return BMaps(vm);
      })
      .then(
        function(res) {
          resolve(res);
        },
        function(e) {
          console.log("遇到了错误", e);
          throw e;
        }
      )
      .catch(function(e) {
        console.log("用户拒绝定位");
        reject(e);
      });
    // }
  });
}

// 添加距离
export function addDistance(vm, data) {
  if (!isArray(data, "Array")) {
    console.log("参数错误");
    return;
  }
  return new Promise(function(resolve, reject) {
    return Maps(vm)
      .then(function() {
        console.log("BMaps");
        return BMaps(vm);
      })
      .then(
        function() {
          console.log("setDistance");
          return setDistance(vm, data);
        },
        function(e) {
          throw e;
        }
      )
      .then(function(response) {
        resolve(response);
      })
      .catch(function(e) {
        console.log("用户拒绝定位");
        reject(e);
      });
    // }
  });
}

function setDistance(vm, data) {
  return new Promise(function(resolve, reject) {
    var lon_lat = sessionStorage.getItem("lon_lat");
    if (!lon_lat) {
      resolve(data);
      return;
    }
    data.forEach(function(item, idx) {
      var getFlatternDistanceText = lon_lat
        .split(",")
        .concat(item.lon_lat.split(","));
      var lonlatdividingLine = 60; // 经度纬度分界线
      var distance = getFlatternDistance(
        +getFlatternDistanceText[1] > lonlatdividingLine
          ? getFlatternDistanceText[0]
          : getFlatternDistanceText[1],
        +getFlatternDistanceText[0] > lonlatdividingLine
          ? getFlatternDistanceText[0]
          : getFlatternDistanceText[1],
        +getFlatternDistanceText[3] > lonlatdividingLine
          ? getFlatternDistanceText[2]
          : getFlatternDistanceText[3],
        +getFlatternDistanceText[2] > lonlatdividingLine
          ? getFlatternDistanceText[2]
          : getFlatternDistanceText[3]
      );
      vm.$set(item, "distance", distance.toFixed(2));
      vm.$set(item, "DISTANCE", distance.toFixed(2));
    });
    var res = addmeter(data);
    resolve(res);
  });
}

// 判断数据类型
export function isArray(obj, type) {
  var objType = Object.prototype.toString.call(obj).slice(8, -1);
  return objType == type;
}

// 微信定位授权
function wxGeolocation() {
  return new Promise(function(resolve, reject) {
    if (navigator.userAgent.indexOf("QQ") != -1) {
      resolve();
      return;
    }
    var signPackage = JSON.parse(window.signPackage);
    var wx = require("weixin-js-sdk");
    if (signPackage && wx) {
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: signPackage.appid,
        timestamp: signPackage.timestamp,
        nonceStr: signPackage.noncestr,
        signature: signPackage.signature,
        jsApiList: ["getLocation"]
      });

      wx.ready(function() {
        wx.getLocation({
          success: function(res) {
            resolve();
          },
          cancel: function(res) {
            console.log("用户拒绝授权获取地理位置");
            reject("用户拒绝授权获取地理位置");
          }
        });

        wx.error(function(res) {
          reject(res.errMsg);
          console.log(res.errMsg);
        });
      });
    }
  });
}

// 腾讯地图
function qqGeolocation(vm) {
  return new Promise(function(resolve, reject) {
    var geolocation = new qq.maps.Geolocation(
      "XXXBZ-ZSQ6F-MULJV-JEFH5-4K3XE-QTBHU",
      "myapp"
    );
    var options = {
      timeout: 8000
    };
    geolocation.getLocation(
      function(position) {
        var cityName = position.city.substr(0, position.city.length - 1);
        getCityId(vm, cityName).then(function(response) {
          if (response.code == 200) {
            var info = {
              cityName: cityName,
              cityId: response.data.id,
              area_code: response.data.standard_code
            };
            sessionStorage.setItem("myLocationInfo", JSON.stringify(info));
            sessionStorage.setItem(
              "lon_lat",
              position.lng + "," + position.lat
            );
            resolve();
          } else {
            reject();
          }
        });
      },
      function(err) {
        reject();
      },
      options
    );
  });
}

// 将对象转为query字符串
export function StringChangeQuery(obj) {
  if (!isArray(obj, "Object") || JSON.stringify(obj) == "{}") {
    console.log("StringChangeQuery传入的参数类型错误");
    return "";
  }
  var query =
    "?" +
    Object.keys(obj)
      .map(k => encodeURIComponent(k) + "=" + encodeURIComponent(obj[k]))
      .join("&");
  return query;
}

// 将对象转为params参数
export function StringChangeParams(obj) {
  if (!isArray(obj, "Object") || JSON.stringify(obj) == "{}") {
    console.log("StringChangeParams传入的参数类型错误");
    return "";
  }
  var query =
    "/" +
    Object.keys(obj)
      .map(k => obj[k])
      .join("/");
  return query;
}

// get请求
export function getAjax(vm, pramas) {
  return new Promise((resolve, reject) => {
    if (!pramas) {
      reject();
    }
    var query = pramas.query || "";
    vm.$http
      .get(
        pramas.url,
        {
          query
        },
        {
          emulateJSON: true
        }
      )
      .then(res => {
        resolve(res.data);
      })
      .catch(res => {
        reject(res);
      });
  });
}

// post请求
export function postAjax(vm, pramas) {
  return new Promise((resolve, reject) => {
    if (!pramas) {
      reject();
    }
    var query = pramas.query || "";
    vm.$http
      .post(pramas.url, query, {
        emulateJSON: true
      })
      .then(res => {
        resolve(res.data);
      })
      .catch(res => {
        console.log("warn");
      });
  });
}

// 获取接口名称
export function getInterfaceName(url) {
  if (!url) {
    throw new Error("请传入接口地址");
  }
  var pramas = url.split("?")[0].split("/");
  return pramas[pramas.length - 1];
}

export function extend() {
  /*
   *target被扩展的对象
   *length参数的数量
   *deep是否深度操作
   */
  var options;
  var name;
  var src;
  var copy;
  var copyIsArray;
  var clone;
  var target = arguments[0] || {};
  var i = 1;
  var length = arguments.length;
  var deep = false;

  // target为第一个参数，如果第一个参数是Boolean类型的值，则把target赋值给deep
  // deep表示是否进行深层面的复制，当为true时，进行深度复制，否则只进行第一层扩展
  // 然后把第二个参数赋值给target
  if (typeof target === "boolean") {
    deep = target;
    target = arguments[1] || {};

    // 将i赋值为2，跳过前两个参数
    i = 2;
  }

  // target既不是对象也不是函数则把target设置为空对象。
  if (typeof target !== "object" && !jQuery.isFunction(target)) {
    target = {};
  }

  // 如果只有一个参数，则把jQuery对象赋值给target，即扩展到jQuery对象上
  if (length === i) {
    target = this;

    // i减1，指向被扩展对象
    --i;
  }

  // 开始遍历需要被扩展到target上的参数

  for (; i < length; i++) {
    // 处理第i个被扩展的对象，即除去deep和target之外的对象
    if ((options = arguments[i]) != null) {
      // 遍历第i个对象的所有可遍历的属性
      for (name in options) {
        // 根据被扩展对象的键获得目标对象相应值，并赋值给src
        src = target[name];
        // 得到被扩展对象的值
        copy = options[name];

        // 这里为什么是比较target和copy？不应该是比较src和copy吗？
        if (target === copy) {
          continue;
        }

        // 当用户想要深度操作时，递归合并
        // copy是纯对象或者是数组
        if (
          deep &&
          copy &&
          (isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))
        ) {
          // 如果是数组
          if (copyIsArray) {
            // 将copyIsArray重新设置为false，为下次遍历做准备。
            copyIsArray = false;
            // 判断被扩展的对象中src是不是数组
            clone = src && jQuery.isArray(src) ? src : [];
          } else {
            // 判断被扩展的对象中src是不是纯对象
            clone = src && jQuery.isPlainObject(src) ? src : {};
          }

          // 递归调用extend方法，继续进行深度遍历
          target[name] = jQuery.extend(deep, clone, copy);

          // 如果不需要深度复制，则直接把copy（第i个被扩展对象中被遍历的那个键的值）
        } else if (copy !== undefined) {
          target[name] = copy;
        }
      }
    }
  }

  function isPlainObject(obj) {
    var proto, Ctor;

    // Detect obvious negatives
    // Use toString instead of jQuery.type to catch host objects
    if (!obj || toString.call(obj) !== "[object Object]") {
      return false;
    }

    proto = getProto(obj);

    // Objects with no prototype (e.g., `Object.create( null )`) are plain
    if (!proto) {
      return true;
    }

    // Objects with prototype are plain iff they were constructed by a global Object function
    Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
    return (
      typeof Ctor === "function" &&
      fnToString.call(Ctor) === ObjectFunctionString
    );
  }

  // 原对象被改变，因此如果不想改变原对象，target可传入{}
  return target;
}

// 判断浏览器类型
export function getBroswerType() {
  let userAgent = navigator.userAgent.toLowerCase();
  if (userAgent.match(/micromessenger/i) == "micromessenger") {
    return "micromessenger";
  } else if (userAgent.match(/alipay/i) == "alipay") {
    return "alipay";
  } else {
    return "";
  }
}

// getBroswerType();
export function reminderHandle(vm, item) {
  vm.itemOnce = window.localStorage.getItem("reportList")
    ? JSON.parse(window.localStorage.getItem("reportList"))
    : {};
  if (
    vm.itemOnce.hasOwnProperty(item.id) &&
    vm.now - vm.itemOnce[item.id] < 864000
  ) {
    vm.showTip("今日已催单，客服将尽快联系医院处理！");
    return;
  }
  vm.itemOnce[item.id] = vm.now;
  window.localStorage.setItem("reportList", JSON.stringify(vm.itemOnce));
  http({
    url: HTTP_URL.feedback,
    params: {
      content:
        "系统消息：该用户点击了订单ID：" +
        item.id +
        "体检报告催单按钮，请尽快处理",
      reminder: 1,
      order_id: item.id
    },
    method: "post"
  }).then(
    res => {
      console.log(res);
      vm.showTip("催单成功，客服将尽快联系医院处理！");
    },
    res => {
      console.log(res);
      vm.showTip("催单失败");
      delete vm.itemOnce[item.id];
      window.localStorage.setItem("reportList", JSON.stringify(vm.itemOnce));
    }
  );
}

// 防抖
export function debounce(func, delay) {
  let timer;
  // ...args指func的参数，args指func的参数组,相当于arguments,var args = arguments
  return function(...args) {
    if (timer) {
      clearTimeout(timer);
    }
    // console.log(arguments, args)
    timer = setTimeout(() => {
      // 调用func,传入args参数数组
      func.apply(this, args);
    }, delay);
  };
}

// 首页埋点
export function MtaH5ClickStat(obj, name = "daishuPeH5Home") {
  if (typeof MtaH5 !== "undefined" && MtaH5 && MtaH5.clickStat) {
    MtaH5.clickStat(name, obj);
  }
}

// 数据埋点
export function MtaH5ClickStatV2(name, obj) {
  if (typeof MtaH5 !== "undefined" && MtaH5.clickStat) {
    MtaH5.clickStat(name, obj);
  }
}

// 缓动函数
// A = A + (B - A) / 2
// 翻译一下就是：
// 我下一秒的位置 = 现在位置 + 现在和初恋之间距离的一半

// A是起始位置；
// B是目标位置；
// rate是缓动速率；
// callback是变化的位置回调，支持两个参数，value和isEnding，表示当前的位置值（数值）以及是否动画结束了（布尔值）；
export function easeout(A, B, rate, callback) {
  if (A == B || typeof A !== "number") {
    return;
  }
  B = B || 0;
  rate = rate || 2;
  var i = 0;

  var step = function() {
    A = A + (B - A) / rate;
    if (
      Math.floor(A) == B ||
      getScrollTop() + getWindowHeight() == getScrollHeight() ||
      i > 10
    ) {
      callback(B, true);
      return;
    }
    callback(A, false);
    i++;
    requestAnimationFrame(step);
  };
  step();
}

function getScrollTop() {
  var scrollTop = 0;
  var bodyScrollTop = 0;
  var documentScrollTop = 0;
  if (document.body) {
    bodyScrollTop = document.body.scrollTop;
  }
  if (document.documentElement) {
    documentScrollTop = document.documentElement.scrollTop;
  }
  scrollTop =
    bodyScrollTop - documentScrollTop > 0 ? bodyScrollTop : documentScrollTop;
  return scrollTop;
}

// 文档的总高度
function getScrollHeight() {
  var scrollHeight = 0;
  var bodyScrollHeight = 0;
  var documentScrollHeight = 0;
  if (document.body) {
    bodyScrollHeight = document.body.scrollHeight;
  }
  if (document.documentElement) {
    documentScrollHeight = document.documentElement.scrollHeight;
  }
  scrollHeight =
    bodyScrollHeight - documentScrollHeight > 0
      ? bodyScrollHeight
      : documentScrollHeight;
  return scrollHeight;
}

// 浏览器视口的高度
function getWindowHeight() {
  var windowHeight = 0;
  if (document.compatMode == "CSS1Compat") {
    windowHeight = document.documentElement.clientHeight;
  } else {
    windowHeight = document.body.clientHeight;
  }
  return windowHeight;
}

// 判断浏览器类型
export function getBroswerUA() {
  const UA = window.navigator.userAgent.toLowerCase();
  if (UA.indexOf("android") > 0) {
    return "Android";
  } else if (/iphone|ipad|ipod|ios/.test(UA)) {
    return "IOS";
  } else {
    return "";
  }
}

/**
 * 将日期转换成中文格式，并附带星期几
 * @param date 日期  例：2018-11-19 => 2018年11月19日 星期一
 * */
export function dateConversion(date) {
  let week = "星期" + "日一二三四五六".charAt(new Date(date).getDay());
  let newDate = date.split(" ")[0].split("-");
  newDate = `${newDate[0]}年${newDate[1]}月${newDate[2]}日 ${week}`;
  return newDate;
}

// ---------- 订单处理相关方法 start ----------
// 新版 订单处理，根据传入参数调用不同的处理接口
export function newOrderEventHandle(vm, code, order, item) {
  switch (code) {
    case 1:
      toPayHandle(vm, order);
    case 2:
      toPayHandle(vm, order);
      break;
    case 3:
      // 再次购买（订单列表、详情）
      toAlignHandle(vm, order);
      break;
    case 6:
      // 催促报告（订单列表、详情）
      reminderV2Handle(vm, order);
      break;
    // case 7:
    //   // 查报告
    //   reportInterpretationHandle(vm, order)
    //   break
    case 8:
      // 确认领取报告（订单列表、详情）
      firmReportHandle(vm, order);
      break;
    case 31:
      // 更改日期（订单列表、详情）
      changeDateHandle(vm, order);
      break;
    case 33:
      // 评价（订单列表、详情）
      toEvaluateHandle(vm, order);
      break;
  }
}
// 订单处理，根据传入参数调用不同的处理接口
export function orderEventHandle(vm, code, order, item) {
  switch (code) {
    case 1:
      // 支付（订单列表、详情）
      toPayHandle(vm, order, item);
      break;
    case 2:
      // 再次购买（订单列表、详情）
      toAlignHandle(vm, order);
      break;
    case 3:
      // 确认领取报告（订单列表、详情）
      firmReportHandle(vm, order);
      break;
    // 催促报告（订单列表、详情）
    case 4:
      reminderV2Handle(vm, order);
      break;
    case 5:
      // 评价（订单列表、详情）
      toEvaluateHandle(vm, order);
      break;
    case 6:
      // 更改日期（订单列表、详情）
      changeDateHandle(vm, order);
      break;
    case 7:
      // 联系客服（订单列表、详情）
      contactServiceHandle(vm, order);
      break;
    case 8:
      // 取消订单（订单列表、详情）
      cancelOrderHandle(vm, order);
    case 12:
      // 取消售后
      cancelOrderHandle(vm, order);
      break;
    case 9:
      // 删除订单（订单列表、详情）
      deleteOrderHandle(vm, order);
      break;
    case 10:
      // 已催报告（订单列表、详情）
      hasten(vm, order);
      break;
    case 13:
    case 14:
      // 赠送好医生卡
      bestowalGoodDoctorCard(vm, order);
      break;
    case 15:
      // 查看订单（报告列表）
      if (order.order_type == 1) {
        // 个检订单的
        reportViewOrderHandle(vm, order);
      } else if (order.order_type == 2) {
        // 好医生卡
        viewGoodDoctorCardOrderDetail(vm, order);
      }
      break;
    case 16:
      // 报告未出（报告列表）
      reportNotOutHandle(vm, order);
      break;
    case 17:
      // 报告解读（报告列表）
      reportInterpretationHandle(vm, order);
      break;
    case 18:
      // 下载报告（报告列表）
      reportDownLoadHandle(vm, order);
      break;
    case 22:
      activateGoodDoctorCard(vm, order);
      break;
    case 24:
      // 好医生卡/经纪人(健康无忧卡) 查看物流
      vm.$router.push(`/doctor-card-logistics/${order.id}`);
      break;
    case 25:
      // 确认收货
      familydoctorConfirmReceipt(vm, order);
      break;
    case 26:
      // 查看报告
      previewPDF(vm, order, item);
      break;
    case 42:
      vm.isShare = true;
      break;
  }
}

// 查看订单（报告列表）
export function reportViewOrderHandle(vm, order) {
  console.log("查看订单：", vm, order);
  vm.$router.push({
    path: "/order-detail",
    query: {
      order_id: order.id
    }
  });
}

// 报告未出（报告列表）
export function reportNotOutHandle(vm, order) {
  console.log("报告未出：", vm, order);
  vm.$refs.PopupConfirm.show({
    title: "报告未出？",
    align: "left",
    content: [
      `您的报告方式为：<i>${order.getReportType}</i>`,
      `预计出报告时间：<i>${order.estimatedGetReportTime}</i>`,
      "若您仍未能获取报告，请联系客服为您紧急处理"
    ],
    buttons: [
      {
        text: "取消",
        onTap() {
          setTimeout(() => {
            vm.$refs.PopupConfirm.hide();
          }, 150);
        }
      },
      {
        text: "联系客服",
        onTap() {
          setTimeout(() => {
            vm.$refs.PopupConfirm.hide();
            contactServiceHandle(vm);
          }, 150);
        }
      }
    ]
  });
}

// 报告解读（报告列表）
export function reportInterpretationHandle(vm, order) {
  if (BROSWER_TYPE === "1" && !ISWEBVIEW) {
    window.location.href =
      "https://apps.daishutijian.com/report/wechat_h5/dist/#/";
  } else {
    window.location.href =
      "http://mp.weixin.qq.com/s?__biz=MzI4MzAyNjk1MQ==&mid=503964419&idx=1&sn=0da3a39ba43138c559258bbe99531c50&chksm=706db06b471a397df72f84d039441b32cbc768388595d62c57becbee7bf08ccb6130ca4c6f0f#rd/";
  }
}

// 查看报告（报告列表）
export function reportDownLoadHandle(vm, order) {
  http({
    url: HTTP_URL.getReportLink,
    params: {
      booking_id: order.id
    }
  }).then(res => {
    window.location.href =
      appPath +
      "resource/pdfjs/generic/web/viewer.html?file=" +
      encodeURIComponent(res.path);
  });
}

// 体检卡订单处理
export function cardOrderEvent(vm, code, order) {
  switch (code) {
    // 支付
    case 1:
      toPayCardOrder(vm, order);
      break;
    // 再次购买
    case 2:
      toBuyCard(vm, order);
      break;
    // 确认领取报告
    case 3:
      // firmReportHandle(vm, order);
      break;
    // 催促报告
    case 4:
      // reminderV2Handle(vm, order);
      break;
    // 评价
    case 5:
      // toEvaluateHandle(vm, order);
      break;
    // 更改日期
    case 6:
      // changeDateHandle(vm, order);
      break;
    // 联系客服
    case 7:
      contactServiceHandle(vm, order);
      break;
    // 取消订单
    case 8:
      cancelOrderHandle(vm, order);
      break;
    // 删除订单
    case 9:
      showDeletePopup(vm, order);
      break;
    // 已催报告
    case 10:
      // hasten(vm, order);
      break;
    // 立即使用
    case 11:
      useCard(vm, order);
      break;
    // 申请售后
    case 12:
      vm.$router.push({
        name: "after-sale",
        query: {
          order_id: order.orderId
        }
      });
      break;
    case 13:
      toGiveCard(vm, order);
      break;
    case 14:
      toGiveCard(vm, order);
      break;
    case 24:
      // 好医生卡/经纪人(健康无忧卡) 查看物流
      vm.$router.push(`/doctor-card-logistics/${order.id}`);
      break;
    case 25:
      // 确认收货
      familydoctorConfirmReceipt(vm, order);
      break;
  }
}

// 1.支付
export function toPayHandle(vm, order, item) {
  console.log("准备付款了");

  if (sessionStorage.getItem("channel") === jindongChannel) {
    // 京东小程序
    jd.miniProgram.redirectTo({
      url: `../pay/pay?order_id=${order.id}`
    });
    return;
  }

  isMiniProgram(function(WEBVIEW) {
    // pocketInfirmarySystem:口袋有福
    // if (WEBVIEW && taifuli != '1' && sessionStorage.getItem('comefrom') !== 'pocketInfirmarySystem') {
    // // if (sessionStorage.getItem('miniappToken') && !localStorage.getItem("miniappToken")) {
    //   apply({
    //     order_id: order.id
    //   })
    //   return
    // }
    let code = company_id === "17" ? 1020 : 1010;
    // let url = `${appPath}wxpay/pay/?order_id=${order.id}&t=${code}`
    let url = `${appPath}wxpay/payment?order_id=${order.id}&t=${code}`;

    if (order.order_type === 2) {
      const btn = order.buttons.find(button => button.code === 1);
      url = btn.url;
      // url = item.url
    }
    // 将主题色带到付款页面
    switch (ENTRANCE) {
      case "建行":
        url += "&themeColor=#09B6F2";
        break;
      case "深大":
        url += "&themeColor=#09b6f2";
        break;
      case "中广核、华大":
        url += "&themeColor=#FF4351";
        break;
      case "南航":
        url += "&themeColor=#FF4351";
        break;
      case "中信":
        url += "&pay_channel=102";
        break;
    }

    // 增加channel参数
    if (sessionStorage.getItem("channel")) {
      url += `&channel=${sessionStorage.getItem("channel")}`;
    }

    // 云兴
    if (sessionStorage.getItem("channel") === "002_13_0000_0000_00") {
      url += `&pay_channel=106`;
    }

    // 增加口袋项目渠道
    if (sessionStorage.getItem("comefrom")) {
      // 跳回小程序的逻辑代码在 tijian\apps\wechat\html\pay_middle.html 文件
      url += `&comefrom=${sessionStorage.getItem("comefrom")}`;
    }
    if (sessionStorage.getItem("comefrom") === "pocketInfirmarySystem") {
      url += `&pay_channel=101`;
    } else if (
      isMiniProgram() &&
      ["001_01_0001_0000_00", "002_01_0001_0000_02"].includes(
        sessionStorage.getItem("channel")
      )
    ) {
      url += `&pay_channel=11`;
    }

    switch (ENTRY_CHANNEL[sessionStorage.getItem("channel")]) {
      case "掌铁":
        url += `&pay_channel=14`;
        break;
    }

    window.location.href = url;
  });
}

export function isMiniProgram(fn) {
  let isMiniprogram = window.__wxjs_environment === "miniprogram";
  fn && fn(isMiniprogram);
  return isMiniprogram;
}

export function isDingDingMiniProgram(fn) {
  var ua = navigator.userAgent.toLowerCase();
  return navigator.userAgent.toLowerCase().indexOf("dingtalk") > -1;
}

export function isWeChat() {
  let ua = window.navigator.userAgent.toLowerCase();
  /* eslint-disable */
  return ua.match(/MicroMessenger/i) == "micromessenger";
  /* eslint-disable */
}

// 判断webview
export function checkWebview(fn) {
  let ua = window.navigator.userAgent.toLowerCase();
  if (isWeChat()) {
    //说明不在微信中
    ISWEBVIEW = false;
    fn && fn(false);
    return;
  }
  isMiniProgram();
}

// 1.卡支付
export function toPayCardOrder(vm, order) {
  isMiniProgram(WEBVIEW => {
    if (WEBVIEW) {
      apply({
        order_id: order.order_id,
        isCard: 1
      });
    } else {
      if (isFamilyDoctor && order.payUrl) {
        window.location.href = order.payUrl;
        return;
      }
      let url = `${appPath}wxpay/pay/?t=1030&order_id=${order.order_id}`;
      window.location.href = url;
    }
  });
}

// 2.再次购买
export function toAlignHandle(vm, order) {
  let reqParams = {
    id: order.packageId,
    data_type: "order"
  };

  getPackageDetailV2(vm, reqParams).then(res => {
    if (res.code === 200) {
      const data = res.data.baseInfo;
      vm.$router.push({
        name: "apply-before",
        query: {
          pid: order.packageId,
          org_id: order.orgId,
          // 解决参数报错
          pids: "",
          is_buy_first: data.is_buy_first,
          is_enable_save_life: data.is_enable_save_life,
          price: data.packagePrice / 100,
          original_price: data.originalPrice / 100
        }
      });
    } else {
      vm.$toast(res.msg);
    }
  });
}

// 2.再次买卡
export function toBuyCard(vm, order) {
  vm.$router.push({
    name: "medicalcard-apply",
    params: {
      id: order.cardId
    }
  });
}

// 3.确认领取报告
export function firmReportHandle(vm, order) {
  vm.$refs.PopupConfirm.show({
    title: "确认",
    align: "center",
    content: ["确认已经获取体检报告？"],
    buttons: [
      {
        text: "取消",
        onTap() {
          setTimeout(() => {
            vm.$refs.PopupConfirm.hide();
          }, 150);
        }
      },
      {
        text: "确认",
        onTap() {
          setTimeout(() => {
            // 发送请求
            confirmReportRequest(
              vm,
              {
                id: order.id
              },
              false
            )
              .then(res => {
                if (res.code === 200) {
                  // 确认成功
                  vm.$refs.PopupConfirm.hide();
                  vm.showReportDialog = false;
                  setTimeout(() => {
                    vm.getOrderList ? vm.getOrderList() : vm.refresh();
                  }, 150);
                } else {
                  vm.$toast(res.msg);
                }
              })
              .catch(() => {
                vm.$toast("请求失败");
              });
          }, 150);
        }
      }
    ]
  });
}

// 4.催促报告
export function reminderV2Handle(vm, order) {
  let content = "";
  if (order.estimatedGetReportTime) {
    content = `给您带来不便非常抱歉，由于部分项目需要送检，会占用一定时间周期，您的报告预计于${
      order.estimatedGetReportTime
    }开出，还请您耐心等候。`;
  } else {
    content = `给您带来不便非常抱歉，由于部分项目需要送检，会占用一定时间周期，还请您耐心等待。`;
  }
  vm.$refs.PopupConfirm.show({
    title: "催报告",
    align: "center",
    content: [content],
    buttons: [
      {
        text: "不行，我要催报告",
        onTap() {
          setTimeout(() => {
            reminder(vm, order)
              .then(res => {
                vm.$refs.PopupConfirm.hide();
                vm.showToast({
                  message: `感谢您的耐心等候，${
                    isWechatSubscription || !brandConfig.showDaishu
                      ? ""
                      : "小袋鼠"
                  }将尽快为您联系医院处理。`,
                  duration: 2000
                });
                setTimeout(() => {
                  vm.getOrderList ? vm.getOrderList() : vm.refresh();
                }, 2000);
              })
              .catch(() => {
                vm.$refs.PopupConfirm.hide();
                vm.showToast({
                  message: "反馈失败，请联系客服处理。",
                  duration: 2000
                });
              });
          }, 150);
        }
      },
      {
        text: "好吧，我再等等",
        onTap() {
          setTimeout(() => {
            vm.$refs.PopupConfirm.hide();
          }, 150);
        }
      }
    ]
  });
}

// 5.评价
export function toEvaluateHandle(vm, order) {
  sessionStorage.setItem("evaluateItemId", order.id);
  vm.$router.push({
    name: "evaluate",
    query: {
      from: vm.$route.name
    }
  });
}

// 6.改期
export function changeDateHandle(vm, order) {
  // 初始化日期选择
  function initPicker() {
    vm.changeDatePicker = vm.$createPicker({
      title: "请选择体检时间",
      data: [
        order.orgSchedule
        // (order.orgSchedule.length)
        // ? order.orgSchedule
        // : [
        //     {
        //       value: '暂无排期',
        //       text: '暂无排期'
        //     }
        //   ]
      ],
      onSelect: (selectedVal, selectedIndex, selectedText) => {
        if (selectedVal[0] === "暂无排期") {
          return;
        }
        // 判断是否选了重复日期
        let oldMedicalTime = order.medicalTime
          .slice(0, 10)
          .replace(/[\u4e00-\u9fa5]/g, "-");
        if (selectedVal[0] === oldMedicalTime) {
          return;
        }
        // 弹确认弹窗给用户确认
        vm.$refs.PopupConfirm.show({
          title: "是否更改订单体检时间为：",
          align: "center",
          content: [dateConversion(selectedVal[0])],
          buttons: [
            {
              text: "取消",
              onTap() {
                setTimeout(() => {
                  vm.$refs.PopupConfirm.hide();
                }, 150);
              }
            },
            {
              text: "确认",
              onTap() {
                setTimeout(() => {
                  if (order.orgSchedule.length) {
                    vm.$refs.PopupConfirm.hide();
                    order.newDate = {
                      medical_time: selectedVal[0],
                      id: order.id
                    };
                    vm.$refs.toast.show({
                      title: "改期中",
                      icon: "loading",
                      duration: 2000
                    });
                    changeDate(vm, order.newDate).then(res => {
                      if (res.code === 200) {
                        vm.$refs.toast.show({
                          title: res.msg,
                          icon: "success",
                          duration: 2000
                        });
                        setTimeout(() => {
                          vm.refresh();
                        }, 200);
                      } else {
                        vm.$refs.toast.show({
                          title: res.msg,
                          icon: "fail",
                          duration: 1500
                        });
                      }
                    });
                  }
                }, 150);
              }
            }
          ]
        });
      }
    });
  }

  // 首次获取排期
  if (order.hasSchedule === undefined) {
    // 获取排期
    vm.$refs.toast.show({
      title: "获取排期中",
      icon: "loading",
      duration: 2000
    });
    http({
      url: HTTP_URL.getNewApplySchedule,
      params: {
        package_id: order.packageId,
        org_id: order.orgId,
        change_date: 1
      }
    }).then(res => {
      console.log("排期列表", res);
      vm.$refs.toast.hide();
      // if (!Object.keys(res.data.schedule).length) {
      // } else {
      let len = Object.keys(res.data.schedule)
        ? Object.keys(res.data.schedule)
        : [];
      let num = 0;
      for (let i = 0; i < len.length; i++) {
        if (Number(res.data.schedule[len[i]].split("|")[1]) > 0) {
          num++;
          break;
        }
      }
      // 是否有排期
      if (len.length < 1 || num === 0) {
        Toast("暂无排期");
      }
      vm.schedule = res.data.schedule;
      vm.popup = true;
      vm.order = order;
      vm.time_period_status = res.data.time_period_status;
      vm.show_schedule_text = res.data.show_schedule_text;
      vm.schedule_type = res.data.schedule_type;
      // return
      // let arr = []
      // for (let key in res) {
      //   let obj = {
      //     value: key,
      //     text: res[key]
      //   }
      //   arr.push(obj)
      // }
      // order.orgSchedule = formatMedicalTime(arr)
      // initPicker(order)
      // vm.changeDatePicker.show()
    });
  } else {
    // 已获取过排期直接展示
    initPicker(order);
    vm.changeDatePicker.show();
  }
}

export function newChangeDateHandle(vm, order, item) {
  // 判断是否选了重复日期
  // console.log(item);
  let oldMedicalTime = order.medicalTime
    .slice(0, 10)
    .replace(/[\u4e00-\u9fa5]/g, "-");
  if (item.date === oldMedicalTime && !item.schedule_times) {
    return;
  }
  // 弹确认弹窗给用户确认
  vm.$refs.PopupConfirm.show({
    title: "是否更改订单体检时间为：",
    align: "center",
    content: [
      dateConversion(item.date) +
        (item.schedule_times ? " " + item.schedule_times : "")
    ],
    buttons: [
      {
        text: "取消",
        onTap() {
          setTimeout(() => {
            vm.$refs.PopupConfirm.hide();
          }, 150);
        }
      },
      {
        text: "确认",
        onTap() {
          setTimeout(() => {
            vm.$refs.PopupConfirm.hide();
            order.newDate = {
              medical_time: item.date,
              id: order.id,
              medical_time_start: item.schedule_times
                ? item.schedule_times.split("-")[0]
                : "",
              medical_time_end: item.schedule_times
                ? item.schedule_times.split("-")[1]
                : ""
            };
            vm.$refs.toast.show({
              title: "改期中",
              icon: "loading",
              duration: 2000
            });
            changeDate(vm, order.newDate).then(res => {
              if (res.code === 200) {
                vm.$refs.toast.show({
                  title: res.msg,
                  icon: "success",
                  duration: 2000
                });
                setTimeout(() => {
                  vm.refresh();
                }, 200);
              } else {
                vm.$refs.toast.show({
                  title: res.msg,
                  icon: "fail",
                  duration: 1500
                });
              }
            });
          }, 150);
        }
      }
    ]
  });
}

// 7.联系客服
export function contactServiceHandle(vm, order) {
  vm.$customerService.onTap();
  // if (!order) {
  //   location.href = `tel:${brandConfig.daishuPhone.replaceAll('-', '')}`
  //   return;
  // }
  // location.href = `tel:${order.phone || order.orgPhone || brandConfig.daishuPhone.replaceAll('-', '')}`
}

// 8.取消订单
export function cancelOrderHandle(vm) {
  vm.isPop = true;
}

// 9.删除订单
export function deleteOrderHandle(vm, order) {
  vm.$refs.PopupConfirm.show({
    title: "确认删除此订单？",
    align: "center",
    content: ["删除后的订单将不可恢复"],
    buttons: [
      {
        text: "取消",
        highlight: false,
        onTap() {
          setTimeout(() => {
            vm.$refs.PopupConfirm.hide();
          }, 150);
        }
      },
      {
        text: "删除",
        highlight: true,
        onTap() {
          setTimeout(() => {
            orderDelete(
              vm,
              {
                id: order.id
              },
              false
            )
              .then(res => {
                vm.$refs.PopupConfirm.hide();
                if (res.code === 200) {
                  vm.$toast(res.msg);
                  if (vm.$route.name === "order-list-v2") {
                    vm.refresh();
                  } else {
                    setTimeout(() => {
                      vm.$router.push({
                        name: "order-list-v2"
                      });
                    }, 1000);
                  }
                }
              })
              .catch(() => {
                vm.$toast({
                  message: "删除失败，请联系客服处理。"
                });
              });
          }, 150);
        }
      }
    ]
  });
}

// 9.删除订单
export function showDeletePopup(vm, order) {
  vm.$refs.PopupConfirm.show({
    title: "确认删除此订单？",
    align: "center",
    content: ["删除后的订单将不可恢复"],
    buttons: [
      {
        text: "取消",
        highlight: false,
        onTap() {
          setTimeout(() => {
            vm.$refs.PopupConfirm.hide();
          }, 150);
        }
      },
      {
        text: "删除",
        highlight: true,
        onTap() {
          deleteCardOrder(vm, order);
        }
      }
    ]
  });
}

// 赠送
export function toGiveCard(vm, order) {
  vm.$router.push({
    name: "medical-card-give",
    params: {
      id: order.orderId
    }
  });
}

function deleteCardOrder(vm, order) {
  http({
    url: HTTP_URL.deleteCardOrder,
    method: "post",
    params: {
      order_id: order.orderId
    }
  }).then(res => {
    vm.$refs.PopupConfirm.hide();
    if (res.code === 200) {
      vm.$toast(res.msg);
      setTimeout(() => {
        vm.$router.back();
      }, 2000);
    } else {
      vm.$toast("删除失败，请联系客服处理。");
    }
  });
}

export function cancelCardOrder(vm, params, order_type = 1) {
  //当order_type === 2  是好医生卡/经纪人健康无忧卡 取消订单

  http({
    url:
      order_type === 1
        ? HTTP_URL.cancelCardOrder
        : HTTP_URL.familydoctorCanCelOrder,
    method: "post",
    params
  }).then(res => {
    if (res.code === 200) {
      vm.$toast(res.msg);
      setTimeout(() => {
        order_type === 1 ? vm.getOrderDetail() : vm.getFamilyCardDetail();
      }, 2000);
    } else {
      vm.$toast("取消失败，请联系客服处理。");
    }
  });
}

export function addCardInvoice(vm, params) {
  http({
    url: HTTP_URL.addCardInvoice,
    method: "post",
    params
  }).then(res => {
    if (res.code === 200) {
      vm.$toast(res.msg);
      setTimeout(() => {
        vm.getOrderDetail();
      }, 1500);
    } else {
      vm.$toast("申请发票失败，请联系客服处理。");
    }
  });
}

// 10.已催报告
export function hasten(vm, order) {
  // vm.showToast({
  //   message: '感谢您的耐心等候，小袋鼠将尽快为您联系医院处理。',
  //   duration: 2000
  // });
}

// 11.立即使用
export function useCard(vm, order) {
  // vm.saveCard(order);
  if (isFamilyDoctor && order.qrCode) {
    window.location.href = order.qrCode;
  } else {
    vm.$router.push({
      name: "package-org",
      query: {
        id: order.orderId,
        isCard: 1,
        card_id: order.cardId
      }
    });
  }
}

// 13 赠送好医生卡
export function bestowalGoodDoctorCard(vm, order) {
  vm.$router.push(`/doctor-card-give/${order.id}`);
}

// 15 查看好医生卡订单详情
export function viewGoodDoctorCardOrderDetail(vm, order) {
  vm.$router.push(`/doctor-card-order-detail/${order.id}`);
}

// 22 立即激活
export function activateGoodDoctorCard(vm, order) {
  if (sessionStorage.getItem("comefrom") === "partner") {
    this.$dialog.alert({
      title: "激活说明",
      message:
        "为保障您可正常使用健康无忧卡的权益，APP暂不支持激活。请到微信公众号‘袋鼠健康’健康管理->我的->体检订单，进行激活并使用相关权益。",
      confirmButtonText: "知道了"
    });
    return;
  }

  // console.log('order:::', order)
  vm.$dialog
    .confirm({
      title: "请确认是否立即激活？",
      message: "激活后即绑定当前账号，无法申请退款，且不支持切换绑定账号",
      confirmButtonText: "立即激活",
      confirmButtonColor: "#FFAB11"
    })
    .then(() => {
      http({
        url: HTTP_URL.familydoctorSelfCardExchange,
        method: "post",
        params: {
          id: order.id
        }
      }).then(res => {
        if (res.code === 200) {
          vm.$toast({
            message: "激活成功",
            duration: 1000
          });
          setTimeout(() => {
            window.location.href = window.healthProjectAgent;
            // vm.$router.push('/doctor-card-home')
          }, 1000);
        } else {
          vm.$toast(res.msg || "网络错误");
        }
      });
    })
    .catch(() => {});
}
// 26查看报告
function previewPDF(vm, order, item) {
  http({
    url: HTTP_URL.getReportLink,
    params: {
      booking_id: order.bookingId
    }
  }).then(res => {
    window.location.href =
      appPath +
      "resource/pdfjs/generic/web/viewer.html?file=" +
      encodeURIComponent(res.path);
  });
}

//25 确认收货

export function familydoctorConfirmReceipt(vm, order) {
  const id = order.order_id || order.id;
  vm.$dialog
    .confirm({
      title: "请确认是否收货",
      message: "签收后，无法更改物流状态",
      confirmButtonText: "确认收货",
      confirmButtonColor: "#FFAB11"
    })
    .then(() => {
      http({
        url: HTTP_URL.familydoctorConfirmReceipt,
        method: "post",
        params: {
          id
        }
      }).then(res => {
        if (res.code === 200) {
          vm.$toast({
            message: "签收成功",
            duration: 1000
          });

          const timer = setTimeout(() => {
            if (
              vm.$route.name === "doctor-card-order-detail" ||
              vm.getFamilyCardDetail
            ) {
              vm.getFamilyCardDetail();
            } else {
              vm.$emit("refresh");
            }

            clearImmediate(timer);
          }, 1500);
        } else {
          vm.$toast(res.msg || "网络错误");
        }
      });
    })
    .catch(() => {});
}

// ---------- 订单处理相关方法 end ----------

// 跳转链接，传入vue实例对象及完整链接，通过识别是站内链接还是站外链接来判断是直接跳转还是路由内跳转
export function jumpLink(payload) {
  let vm = payload.vm || ""; // vue实例对象
  let url = payload.url || ""; // 跳转的链接
  let isReplaceRouter = payload.isReplaceRouter || false; // 跳转是否需要在访问历史中使用这个新地址覆盖掉当前访问页面的路由记录
  if (!url) {
    return;
  }
  if (url.split("/h5#/")[1]) {
    if (isReplaceRouter) {
      vm.$router.replace({
        path: `/${url.split("/h5#/")[1]}`
      });
    } else {
      vm.$router.push({
        path: `/${url.split("/h5#/")[1]}`
      });
    }
  } else {
    if (!/http:\/\/|https:\/\/|\/\//.test(url)) {
      url = "//" + url;
    }
    window.location.href = url;
  }
}

// js动态同步加载外部js文件
export function loadJs(options) {
  var script = document.createElement("script");
  if (script.addEventListener && options.callback) {
    script.addEventListener("load", options.callback, false);
  } else if (script.attachEvent) {
    script.attachEvent("onreadystatechange", function() {
      var target = window.event.srcElement;
      if (target.readyState == "loaded" || target.readyState == "complete") {
        options.callback && callback.call(target);
      }
    });
  }
  if (options.params && isArray(options.params, "Object")) {
    for (var key in options.params) {
      script[key] = options.params[key];
    }
  }
  script.src = options.url;
  document.getElementsByTagName("head")[0].appendChild(script);
}

// 将数字或字符串转换为加密字符串
// textEncryption(1)   => '1'
// textEncryption(123) => '1*3'
// textEncryption(123456) => '12**56'
export function textEncryption(string) {
  let str = String(string);
  let len = str.length;
  let prev = "";
  let next = "";
  let asterisk = "";
  if (len === 1) {
    prev = str.slice(0, 1);
    next = "";
    asterisk = "";
  } else if (len === 2) {
    prev = str.slice(0, 1);
    next = "";
    asterisk = "*";
  } else if (len > 2) {
    let average = Math.floor(len / 3);
    prev = str.slice(0, average);
    next = str.slice(len - average, len);
    for (let i = 0, num = len - average * 2; i < num; i++) {
      asterisk += "*";
    }
  }
  return prev + asterisk + next;
}

// 跳转细项页
export function toAddItem(vm, data = {}) {
  let query = {
    ...vm.$route.query,
    pids: vm.queryParam.allPid,
    medicalcard_user_id: vm.$route.query.medicalcard_user_id || ""
  };
  Object.assign(query, data);
  vm.$router.push({
    name: "apply-addItem",
    query
  });
}

// 页面刷新,不适用keep-alive的页面
export function reload(vm) {
  vm.$router.replace("/reload");
}

/* 解决弹出层滚动穿透
 * 引入该方法并调用，只需调用一次
 * 缓存返回值到变量a
 * 在弹出层需要禁止穿透时传a(true)
 * 恢复传a(false)
 * 示例 src/components/news/PopupEvaluate.vue
 */
export function fixedRollThrough() {
  let bodyEl = document.body;
  let top = window.scrollY;
  return function(forbidScroll) {
    // 禁止穿透
    if (forbidScroll) {
      top = window.scrollY;
      bodyEl.style.position = "fixed";
      bodyEl.style.top = -top + "px";
      bodyEl.style.left = "0";
      bodyEl.style.right = "0";
    } else {
      bodyEl.style.position = "";
      bodyEl.style.top = "";
      bodyEl.style.left = "";
      bodyEl.style.right = "";
      window.scrollTo(0, top);
    }
  };
}

// 同步套餐浏览历史
export function synchronizedPackageHistory() {
  return new Promise(function(resolve, reject) {
    let requestIng = localStorage.getItem("requestIng");
    if (!user_id || requestIng) {
      resolve();
      return;
    }
    localStorage.setItem("requestIng", "true");
    let packageHistory = JSON.parse(localStorage.getItem("packageHistory"));
    let idList = [];
    // 如果本地设备中有套餐浏览历史，提取里面的id及访问时的时间戳
    if (packageHistory) {
      for (let i = 0, len = packageHistory.length; i < len; i++) {
        if (!packageHistory[i].disabled && packageHistory[i].package_id) {
          idList.push({
            id: packageHistory[i].package_id,
            timeStamp: packageHistory[i].timeStamp
          });
        }
      }
    }
    // 执行同步请求
    if (idList.length) {
      http({
        method: "post",
        url: HTTP_URL.cachePackageBrowse,
        params: {
          data: idList
        }
      }).then(res => {
        localStorage.removeItem("requestIng");
        if (res.code === 200) {
          localStorage.removeItem("packageHistory");
        }
        resolve();
      });
    } else {
      localStorage.removeItem("requestIng");
      resolve();
    }
  });
}
// 解决输入框，文本域软键盘收起页面不会弹问题（失去焦点时调用该方法）
export function pageHoming() {
  setTimeout(function() {
    let scrollHeight =
      document.documentElement.scrollTop || document.body.scrollTop || 0;
    window.scrollTo(0, Math.max(scrollHeight - 1, 0));
  }, 100);
}

export function pageRebound() {
  let currentPosition, timer;
  let speed = 1;
  timer = setInterval(function() {
    currentPosition =
      document.documentElement.scrollTop || document.body.scrollTop;
    currentPosition -= speed;
    window.scrollTo(0, currentPosition);
    currentPosition += speed;
    window.scrollTo(0, currentPosition);
    clearInterval(timer);
  }, 1);
}
// 微信授权跳转
export function linktoAuth(route) {
  // 获取跳转的url
  let beforeUrl = getLinktoAuthUrl(route);
  let url = encodeURIComponent(beforeUrl);
  document.cookie = `return_url=${url};path=/`;
  location.replace(`${appPath}wechat/auth_entrance`);
}

// 授权前url的拼接
export function getLinktoAuthUrl(route) {
  // 分享的url和授权回调的url不一样
  let url = !route
    ? window.location.href
    : location.href.split("#")[0] + "#" + route.fullPath;
  let channel = sessionStorage.getItem("channel");
  let comefrom = sessionStorage.getItem("comefrom");
  url =
    url.indexOf("channel") !== -1 || !channel
      ? url
      : splicingURL({
          url,
          name: "channel",
          value: channel
        });
  // 判断是否有缓存机构分享的图片和名称
  url = !sessionStorage.getItem("channelOrgInfo")
    ? url
    : splicingURL({
        url,
        name: "channelOrgInfoId",
        value: JSON.parse(sessionStorage.getItem("channelOrgInfo")).org_id
      });
  url = !comefrom
    ? url
    : splicingURL({
        url,
        name: "comefrom",
        value: comefrom
      });
  return url;
}

// 对url塞入想要的字段
export function splicingURL({ url, name, value }) {
  // 没有的话把进入首页的channel加入到 授权回调的url里
  if (url.indexOf(name) !== -1 || !url) {
    return url;
  }
  let urlArr = url.split("?");
  if (urlArr.length >= 3 || urlArr[urlArr.length - 1].indexOf("#") === -1) {
    return `${url}&${name}=${value}`;
  } else {
    return `${url}?${name}=${value}`;
  }
}

// 获取跳转注册页要带的query, 一般传入当前路由或者注册页回跳路由
export function getRegisterQuery(route) {
  let return_url = route.name;
  let query = {
    return_url,
    version: "NEW"
  };
  query = Object.assign(query, route.query);
  let params = "";
  if (route.params) {
    for (let key in route.params) {
      params = `${key}_${route.params[key]}`;
      break;
    }
    if (params.length) {
      query.params = params;
    }
  }
  return query;
}
// 类似于array.indexof, 不严格查找
export function indexOfnoStrict(arr, val) {
  let idx;
  if (!arr.length) return -1;
  let hasItem = arr.some((id, i) => {
    idx = i;
    return +id === +val;
  });
  if (hasItem) {
    return idx;
  } else {
    return -1;
  }
}

export function isIOS() {
  var u = navigator.userAgent;
  var isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
  return !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
}

// 监听软键盘收起事件
export function addEventLenerKeyboardUpDown({ up, down }) {
  //Android
  //获取原窗口的高度
  if (!isIOS()) {
    var originalHeight =
      document.documentElement.clientHeight || document.body.clientHeight;
    window.οnresize = function() {
      //键盘弹起与隐藏都会引起窗口的高度发生变化
      var resizeHeight =
        document.documentElement.clientHeight || document.body.clientHeight;
      if (resizeHeight - 0 < originalHeight - 0) {
        up && up();
        //当软键盘弹起，在此处操作
      } else {
        //当软键盘收起，在此处操作
        down && down();
      }
    };
  } else {
    // ios
    document.body.addEventListener("focusin", () => {
      //软键盘弹出的事件处理
      up && up();
    });
    document.body.addEventListener("focusout", () => {
      //软键盘收起的事件处理
      down && down();
    });
  }
}

// 身份证验证
export function testIdCard(sId) {
  // console.log(sId);

  if (!sId) {
    return "请输入证件号码";
  }
  sId = String(sId);
  if (!sId.match(/^(\d{15}$|^\d{18}$|^\d{17}(\d|X|x))$/gi)) {
    return "身份证号格式不正确";
  }

  var card_area = {
    11: "北京",
    12: "天津",
    13: "河北",
    14: "山西",
    15: "内蒙古",
    21: "辽宁",
    22: "吉林",
    23: "黑龙江",
    31: "上海",
    32: "江苏",
    33: "浙江",
    34: "安徽",
    35: "福建",
    36: "江西",
    37: "山东",
    41: "河南",
    42: "湖北",
    43: "湖南",
    44: "广东",
    45: "广西",
    46: "海南",
    50: "重庆",
    51: "四川",
    52: "贵州",
    53: "云南",
    54: "西藏",
    61: "陕西",
    62: "甘肃",
    63: "青海",
    64: "宁夏",
    65: "新疆",
    71: "台湾",
    81: "香港",
    82: "澳门",
    91: "国外"
  };
  var iSum = 0;
  var info = "";
  var card_info = Array(2);
  sId = sId.replace(/x$/i, "a");
  if (sId.length == 0) {
    return "身份证为空";
  }

  if (card_area[parseInt(sId.substr(0, 2))] == null) {
    return "非法证件，你的地区填写有错误请仔细填写";
  }
  var sBirthday =
    sId.substr(6, 4) +
    "-" +
    Number(sId.substr(10, 2)) +
    "-" +
    Number(sId.substr(12, 2));
  var d = new Date(sBirthday.replace(/-/g, "/"));
  if (
    sBirthday !=
    d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()
  ) {
    return "非法证件，请仔细填写";
  }

  for (var i = 17; i >= 0; i--) {
    iSum += (Math.pow(2, i) % 11) * parseInt(sId.charAt(17 - i), 11);
  }

  if (iSum % 11 != 1 || sId.length > 19) {
    return "非法证号，请认真填写";
  }

  var age = new Date().getFullYear() - d.getFullYear();
  card_info[0] = card_area[parseInt(sId.substr(0, 2))];
  card_info[1] = sBirthday;
  card_info[2] = age;
  card_info[3] = sId.substr(16, 1) % 2 ? "男" : "女";
  return card_info;
}

// 判断是否华西医院
export function isHuaxiOrg() {
  let channel =
    sessionStorage.getItem("channel") || getUrlSpecifiedParam("channel");
  return channel && channel.indexOf("001_05_0073") !== -1;
}

export function getMiddlePlatform() {
  let origin = location.origin;
  let url = "";
  if (origin.includes("apps")) {
    url = `${origin}/daishu_component/public/middle-platform-fe/`;
  } else if (origin.includes("test")) {
    url = `${origin}/services_component2/middle-platform-fe/`;
  } else if (origin.includes("localhost")) {
    // 本地根据实际情况自行替换
    url = `http://localhost:8081/`;
  }
  return url;
}

export function getOriginUrl() {
  return location.origin + location.pathname;
}

export function encrypt_aes(text) {
  if (!text) return;
  try {
    let ciphertext = AES.encrypt(text, "dsjk").toString();
    return ciphertext;
  } catch (err) {
    console.log("err:", err);
    return undefined;
  }
}

export function decrypt_aes(text) {
  if (!text) return;
  try {
    let bytes = AES.decrypt(text, "dsjk");
    let originalText = JSON.parse(bytes.toString(Utf8));
    return originalText;
  } catch (err) {
    console.log("err:", err);
    return undefined;
  }
}

export function baiDuMtaEvent(options) {
  if (!options || !Array.isArray(options)) return;
  console.log(["_trackEvent", ...options]);
  _hmt && _hmt.push && _hmt.push(["_trackEvent", ...options]);
}

export function toNucleicAcid(url) {
  sessionStorage.getItem("lon_lat") &&
    (url += `&lon_lat=${sessionStorage.getItem("lon_lat")}`);
  url += `&city_name=${store.state.currentCity.city_name}`;
  // window.location.replace(`https://apps.dsjkyy.com/wechat/home/covid_entrance?redirect=${encodeURIComponent(url)}`)
  window.location.href = `${ZTPREFIXLOGIN}?redirect=${encodeURIComponent(url)}`;
}

export function flatten(arr) {
  let result = [];
  for (let i = 0; i < arr.length; i++) {
    if (Array.isArray(arr[i])) {
      result = result.concat(this.flatten(arr[i]));
    } else {
      result.push(arr[i]);
    }
  }
  return result;
}
